import { gql } from '@apollo/client';

export const UPDATE_APP_SECTION_PERMISSION = gql`
  mutation UpdateAppSectioPermission($input: UpdateAppSectionPermissionInput) {
    updateAppSectionPermission(input: $input) {
      id
    }
  }
`;
